import React from "react";
import convrtx from "../../../Images/Client/convrtx.webp";
import ACR from "../../../Images/Client/ACR.webp";
import pinaheart from "../../../Images/Client/pinaheart_logo.webp";
import realTime from "../../../Images/Client/realTime.webp";
import realisticus from "../../../Images/Client/realisticus.webp";
import STEER from "../../../Images/Client/STEER_Logo.webp";
import videmak from "../../../Images/Client/videmak.webp";
import proaxiom from "../../../Images/Client/proaxiom.webp";
import Atithi from "../../../Images/Client/atithi.webp";
import enfinyexim from "../../../Images/Client/enfinyexim.webp";
import jewelbook from "../../../Images/Client/jewelbook.webp";
import auxilionetwork from "../../../Images/Client/auxilionetwork.webp";
import portboard from "../../../Images/Client/portboard.webp";
import iiigel from "../../../Images/Client/iiigel.webp";
import soor from "../../../Images/Client/soor.webp";



import { Container } from "react-bootstrap";

export const ClientsImages = [
  { src: convrtx, alt: "clients" },
  { src: pinaheart, alt: "clients" },
  { src: realTime, alt: "clients" },
  { src: realisticus, alt: "clients" },
  { src: ACR, alt: "clients" },
  { src: STEER, alt: "clients" },
  { src: videmak, alt: "clients" },
  { src: proaxiom, alt: "clients" },
  { src: Atithi, alt: "clients" },
  { src: enfinyexim, alt: "clients" },
  { src: auxilionetwork, alt: "clients" },
  { src: portboard, alt: "clients" },
  { src: jewelbook, alt: "clients" },
  { src: iiigel, alt: "clients" },
  { src: soor, alt: "clients" },


];

const MajorClient = () => {
  return (
    <section className="our_client  ">
      <Container>
        <h1 className="heading"> Trusted by Industry Leaders Worldwide</h1>
        <p className="mt-3 text-center">
          Skyline Infosys is proud to partner with some of the most renowned
          names across diverse industries. Our commitment to delivering
          innovative solutions has earned us the trust of global leaders in
          technology, healthcare, finance, and retail. By tailoring our services
          to their unique needs, we help drive their success and growth. Join
          our network of satisfied clients and experience the difference!
        </p>
        <div className="client_img_box mt-5">
          {ClientsImages.map((image, index) => (
            <div className="img_box" key={index}>
              <img src={image.src} alt={image.alt} loading="lazy" />
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default MajorClient;
